if (GLOBAL_SCRIPTS.CONTROLLER !== 'search') {
  import(/* webpackChunkName: 'components/resultList' */'./resultList.css');
}

const basketMulticottageViewModule = () => import(/* webpackChunkName: 'components/basketMulticottageView' */'../../basketMulticottage/basketMulticottage');
const flexModalModule = () => import(/* webpackChunkName: 'components/flexModal' */'../../flexModal/flexModal');
const flexDatesViewModule = () => import(/* webpackChunkName: 'components/flexDatesView' */'../flexDates/flexDates');
const dropDownListModule = () => import(/* webpackChunkName: 'components/dropDownList' */'../../dropDownList/dropDownList');
const bookingFormModule = () => import(/* webpackChunkName: 'components/bookingForm' */'../../bookingForm/bookingForm');
const heightEqualizerModule = () => import(/* webpackChunkName: 'utils/heightEqualizer' */'../../../utils/js/heightEqualizer');
const compareModule = () => import(/* webpackChunkName: 'components/compare' */'../../compare/compare');

import { getUrlParameter } from '../../../utils/js/getUrlParameter';

import { merchandisingBannerTpl } from '../../merchandising/merchandising';

import {cartoucheDomain} from '../cartouche/cartoucheDomain';
import {cartoucheHousing} from '../cartouche/cartoucheHousing';
import { cartoucheMultiCottage } from '../../cartoucheMultiCottage/cartoucheMultiCottage';
import { cartoucheMultiCottageProduct } from '../../cartoucheMultiCottageProduct/cartoucheMultiCottageProduct';

export const ResultsListView = Backbone.View.extend({
  events: {
    'click .js-displayHousings': 'displayHousings',
    'click .js-searchPagination': 'paginate',
    'click .js-housingMoreInfo': 'housingMoreInfo'
  },
  initialize: function (options) {
    this.setElement(options.element);
    this.model = options.model;
    this.mainEngineModel = this.model.get('mainSearch');
    this.filtersModel = this.model.get('filters');
    this.numberOfPlaceholder = null;
    this.cacheWordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.wordingResults = SEARCH_SCRIPTS.WORDING_RESULT;
    this.wordingsCommon = GLOBAL_SCRIPTS.WORDINGS_COMMON;
    this.wordingsMultiCottage = GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE;
    this.banner = merchandisingBannerTpl;
    this.fancyboxView = null;
    this.$resultListHeader = $('.resultList-Header');
    this.$resultListContainer = $('.domainAccommodations-resultListContainer');
    this.$resultListIdContainer = $('#js-resultListContainer');
    this.$resultList = $('#js-resultList');
    this.$sortDropdown = $('#resultList-HeaderSortSelector.js-dropDownList-container');
    this.$resultListHeaderText = $('.js-resultList-headerText');
    this.$resultListHeaderNoHousingAlert = $('.resultList-HeaderNoHousingAlert');
    this.$nbResults = $('#totalresults');
    this.firstLoad = true;
    this.indexhasHousing = 0;
    this.arrTrackingHousingId = [];
    this.popinCottageCache = [];
    this.hasMulticottage = this.model.get('mainSearch').getResume().accommodationNb > 1;
    this.hasBasket = sessionStorage.getItem('basketDatas') !== null;
    this.listNumber = this.hasBasket && JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[0].isFilled ? 2 : 1;
    this.cartouche = (datas, force_use_cartouche_housings, should_we_track_cartouche) => {
      if (should_we_track_cartouche) {
        /** Chaque fois que le dom d'une cartouche est généré (pour ajout au dom), on ajoute aussi les données nécessaires pour
         * déclencher l'event "search_results_displayed".
         * Aussi, en faisant comme ça, l'ordre des éléments dans ce tableau est le même que l'ordre des cartouches dans la page.
         * */
        trackResultItems.push(datas.item);
      }

      if (force_use_cartouche_housings || SEARCH_SCRIPTS.GROUP !== 'offer') {
        return cartoucheHousing(datas);
      } else {
        return cartoucheDomain(datas);
      }
    };
    this.listenTo(dispatcher, 'search:resultList:render', this.render);
    this.listenTo(dispatcher, 'search:resultList:sort', this.sortResult);
    this.listenTo(dispatcher, 'search:resultList:handleSortByDistance', this.handleSortByDistance);
    this.listenTo(dispatcher, 'search:resultList:denySortByDistance', this.denySortByDistance);
    this.listenTo(dispatcher, 'search:resultList:showLightDetails', this.showLightDetails);
    this.listenTo(dispatcher, 'search:resultList:callLightDetails', this.callLightDetails);
    this.listenTo(dispatcher, 'search:resultList:initAfterLightDetails', this.initAfterLightDetails);
    this.listenTo(dispatcher, 'search:resultList:displayResultList', this.displayResultList);
    this.listenTo(dispatcher, 'search:resultList:tabChanged', this.tabChangedCallback);
    this.listenTo(dispatcher, 'search:resultList:initFancyMerchOffer', this.initFancyMerchOffer);
    this.listenTo(dispatcher, 'search:resultList:displayHousings', this.displayHousings);

    this.showLightDetails('#js-resultListContainer');

    heightEqualizerModule().then(({heightEqualizer}) => {window.heightEqualizer = heightEqualizer;});

    dropDownListModule().then(({DropDownList}) => {
      const dropDownSortParameters = {
        containerSelector: '.js-sortResult',
        itemSelector: '.js-sortResult-item',
        labelSelector: '.js-sortResult-label',
        triggeredAction: 'search:resultList:sort',
        datas: ['sort', 'order']
      };

      new DropDownList(dropDownSortParameters);
    });

    // init article message
    this.initArticleMessages();

    // init bt voir plus
    this.initSeeMoreBtn();

    // init guirlande de noel
    if (!DEVICE.isDesktop) {
      $('.ctDom').each((_i, target) => {
        this.eventUspJingleBells(target);
      });
    }

    // Initialise basket
    if (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' || GLOBAL_SCRIPTS.CONTROLLER === 'product') {
      basketMulticottageViewModule().then(({BasketMulticottageView}) => {
        if (this.hasBasket) {
          let datasBasket = JSON.parse(sessionStorage.getItem('basketDatas'));
          datasBasket.openBasket = false;
          sessionStorage.setItem('basketDatas', JSON.stringify(datasBasket));
        }

        this.basketMulticottageView = new BasketMulticottageView(this.mainEngineModel);
      });
    }

    // init cartouche MSG
    this.initCartoucheMsgPopin();

    // handling counterproposal
    if (!this.hasMulticottage) {
      this.displayCounterProposal(true);
    }

    flexDatesViewModule().then(({FlexDatesView}) => {
      // instanciate flexDates view
      new FlexDatesView({model: this.model});
    });

    // suppression de l'autoclose du tri
    if (DEVICE.isMobile) {
      $('#sortListContainer').removeClass('api_toggleAutoClose');
    }

    $(document).on('click', e => {
      const $this = $(e.target);
      $('.accCart-advantages--title, .accCart-cacContainer').removeClass('tooltip-active');
      if ($this.closest('.accCart-advantages--title').length) {
        $this.parent().addClass('tooltip-active');
      }
      if ($this.closest('.accCart-cacContainer').length) {
        $this.parent().addClass('tooltip-active');
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Side-by-side option_click',
          gaLabel: $this.parents('.accCart-mainInfos').find('.accCart-housingTitle').html(),
          event: 'clickEvent'
        });
      }
    });

    $(document).on('click', '.js-seeDispos', e => {
      const $target = $(e.target);
      e.preventDefault();

      flexModalModule().then(({flexModal}) => {
        flexModal.initAndShow({
          mainEngineModel: this.mainEngineModel,
          housing_code: $target.attr('data-housing-code'),
          housing_label: $target.attr('data-housing-label'),
          housing_type: $target.attr('data-housing-type'),
          product_code: $target.attr('data-product-code'),
          housing_comfortLevelName: $target.attr('data-housing-comfortlevelname'),
          housing_typeName: $target.attr('data-housing-typename'),
          product_name: $target.attr('data-product-name'),
          housing_maxCapacity: $target.attr('data-housing-maxcapacity'),
          housing_maxBabies: $target.attr('data-housing-maxbabies'),
          housing_maxChildren: $target.attr('data-housing-maxchildren'),
          housing_maxAdults: $target.attr('data-housing-maxadults'),
          housing_maxPets: $target.attr('data-housing-maxpets'),
          actionCodeCode: $target.attr('data-actionCodeCode'),
          actionCodeName: $target.attr('data-actionCodeName'),
          housingName: $target.attr('data-housingName'),
          housingCode: $target.attr('data-housingCode'),
          priceOriginal: $target.attr('data-priceOriginal'),
          pricePromo: $target.attr('data-pricePromo'),
          priceDiscount: $target.attr('data-priceDiscount'),
          stock: $target.attr('data-stock'),
          destinationCode: $target.attr('data-destinationCode'),
          countryName: $target.attr('data-countryName'),
          countryCode: $target.attr('data-countryCode'),
          regionCode: $target.attr('data-regionCode')
        });

        Tracking.dataLayerPush({
          clickCode: 'clickCalendarPricesDates',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Calendar prices - Cottage unavailable',
          gaLabel: $target.text().trim(),
          event: 'clickEvent'
        });
      });
    });

    // Déclenchement de l'event search_request au chargement d'une page liste de résultats (même si la recherche est gérée en twig)
    dispatcher.trigger('searchModel:searchRequestEvent', SEARCH_SCRIPTS.IS_USER_SEARCH);

    if (typeof trackResultItems !== 'undefined') {
      // Déclenchement de l'event search_results_displayed au chargement d'une page liste de résultats
      this.triggerSearchResultsEvent(SEARCH_SCRIPTS.IS_USER_SEARCH, true);
    }

    this.displayPushBottomMultiCottage();

    // Init booking form
    bookingFormModule().then(({BookingForm}) => {
      this.bookingForm = new BookingForm();
    });

    $(document).on('click', '.js-openCottageDetailsOnImage', e => {
      $(e.target).closest('.accCart').find('.js-lightCottageDetails').trigger('click');
    });

    if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B' ) {
      $(document).on('click', '.js-openMobileMap', e => {
        $('.js-open-map').trigger('click');
      });
    }
  },

  triggerSearchResultsEvent: function (is_user_search, is_first_load) {
    /** Fonction déclenchant l'event de tracking "search_results_displayed".
     * Cet event, sauf changement est censé se déclencher à l'affichage de résultats de recherche.
     * Il permet de faire remonter des domaines mais aussi des cottages selon le type de page liste sur laquelle on est.
     *
     * is_user_search est censé être à 1 uniquement si l'event est déclenché suite à une requête search de type "ajax" ou lors du chargement d'une
     * page si et seulement si le paramètre d'url "user_search" est présent.
     *
     * L'équipe WebA se servira de cette info pour différencier les requêtes de recherche effectuées directement suite à une action de
     * l'utilisateur.
     * */
    const search_arrivalDate = this.mainEngineModel.get('arrivalDate');
    const search_departureDate = this.mainEngineModel.get('departureDate');
    const hasDates = search_arrivalDate !== '' && search_departureDate !== '';
    const multiparticipantsModel_0 = this.mainEngineModel.get('multiparticipants')[0];
    const multiparticipantsModel_1 = this.mainEngineModel.get('multiparticipants')[1];
    const hasMulticottage = this.mainEngineModel.get('accommodationNb') > 1;
    let searchResultsEvent = {
      event: 'search_results_displayed',
      is_user_search: is_user_search,
      sub_event: is_first_load ? 'PageList Results' : 'Update PageList Results',
      old_ga_category: PAGE_SCRIPTS.page_template,
      old_ga_label: is_first_load ? 'First load' : (_.indexOf(Object.keys(this.model.changedAttributes()), 'sort') > -1 ? 'sort' : this.filtersModel.get('lastModifiedFilter') !== '' ? 'Update Filters & Sort' : this.model.get('eventType') === 'clickOnFlexDate' ? 'Update Flex date bar' : 'Update Main Search'),
      list_results_number: trackResultItems.length,
      search_adult_number: multiparticipantsModel_0.adults,
      search_senior_number: multiparticipantsModel_0.seniors,
      search_children_number: multiparticipantsModel_0.ages.length,
      search_children_age: JSON.stringify(multiparticipantsModel_0.ages),
      search_number_person: multiparticipantsModel_0.adults + multiparticipantsModel_0.seniors + multiparticipantsModel_0.ages.length,
      search_pet_number: multiparticipantsModel_0.pets,
      multicottage: this.mainEngineModel.get('accommodationNb') === 1 ? 'no' : 'yes',
      search_start_date: search_arrivalDate,
      search_end_date: search_departureDate,
      search_start_day_of_week: hasDates ? new Date(search_arrivalDate).toLocaleDateString(undefined, {weekday: 'long'}).replace(/\./gi, '') : '',
      search_length_of_stay: hasDates ? genericDate.diff(new Date(search_arrivalDate), new Date(search_departureDate)) : ''
    };

    if (hasMulticottage) {
      searchResultsEvent = {
        ...searchResultsEvent,
        search_adult_number: multiparticipantsModel_0.adults + multiparticipantsModel_1.adults,
        search_senior_number: multiparticipantsModel_0.seniors + multiparticipantsModel_1.seniors,
        search_children_number: multiparticipantsModel_0.ages.length + multiparticipantsModel_1.ages.length,
        search_children_age: JSON.stringify(multiparticipantsModel_0.ages.concat(multiparticipantsModel_1.ages)),
        search_number_person: multiparticipantsModel_0.adults + multiparticipantsModel_0.seniors + multiparticipantsModel_0.ages.length + multiparticipantsModel_1.adults + multiparticipantsModel_1.seniors + multiparticipantsModel_1.ages.length,
        search_pet_number: multiparticipantsModel_0.pets + multiparticipantsModel_1.pets,
        search_adult_number_1: multiparticipantsModel_0.adults,
        search_senior_number_1: multiparticipantsModel_0.seniors,
        search_children_number_1: multiparticipantsModel_0.ages.length,
        search_pet_number_1: multiparticipantsModel_0.pets,
        search_children_age_1: JSON.stringify(multiparticipantsModel_0.ages),
        search_number_person_1: multiparticipantsModel_0.adults + multiparticipantsModel_0.seniors + multiparticipantsModel_0.ages.length,
        search_adult_number_2: multiparticipantsModel_1.adults,
        search_senior_number_2: multiparticipantsModel_1.seniors,
        search_children_number_2: multiparticipantsModel_1.ages.length,
        search_pet_number_2: multiparticipantsModel_1.pets,
        search_children_age_2: JSON.stringify(multiparticipantsModel_1.ages),
        search_number_person_2: multiparticipantsModel_1.adults + multiparticipantsModel_1.seniors + multiparticipantsModel_1.ages.length
      };
    }

    /**
     * Remontée des 3 premiers éléments affichés
     */
    if (trackResultItems.length) {
      searchResultsEvent.search1 = trackResultItems[0].cache.housingCode;
      if (trackResultItems.length > 1) {
        searchResultsEvent.search2 = trackResultItems[1].cache.housingCode;
        if (trackResultItems.length > 2) {
          searchResultsEvent.search3 = trackResultItems[2].cache.housingCode;
        }
      }
    }

    // Ajout des clés spécifiques aux résultats de recherche
    for (let trackResultItem of trackResultItems) {
      const multiparticipantsModel_0 = this.mainEngineModel.get('multiparticipants')[0];
      const multiparticipantsModel_1 = this.mainEngineModel.get('multiparticipants')[0];

      trackResultItem.additionnal_item_infos = {
        item_adults_number: multiparticipantsModel_0.adults + (hasMulticottage ? multiparticipantsModel_1.adults : 0),
        item_seniors_number: multiparticipantsModel_0.seniors + (hasMulticottage ? multiparticipantsModel_1.seniors : 0),
        item_children_number: multiparticipantsModel_0.ages.length + (hasMulticottage ? multiparticipantsModel_1.ages.length : 0),
        item_pets_number: multiparticipantsModel_0.pets + (hasMulticottage ? multiparticipantsModel_1.pets : 0),
        item_children_age: JSON.stringify(multiparticipantsModel_0.ages) + (hasMulticottage ? JSON.stringify(multiparticipantsModel_1.ages) : 0),
        item_number_person: this.mainEngineModel.get('totalParticipants'),
        item_start_date: trackResultItem.cache.date,
        item_end_date: trackResultItem.cache.dateEnd,
        item_start_day_of_week: new Date(trackResultItem.cache.date).toLocaleDateString(undefined, {weekday: 'long'}).replace(/\./gi, ''),
        item_length_of_stay: genericDate.diff(new Date(trackResultItem.cache.date), new Date(trackResultItem.cache.dateEnd))
      };
    }

    /**
     * Remontée des résultats de recherche
     * @type {{items: *}}
     */
    const itemsParams = {
      datas: trackResultItems
    };

    if (SEARCH_SCRIPTS.GROUP !== 'offer' || (this.model.get('ajaxParametersCache').group === 'offer' && SEARCH_SCRIPTS.GROUP === 'offer')) {
      /**
       * On inclut le paramètre pour la pagination uniquement si : page de type "liste de housings" (fp/cottages ou certaines sck par exemple) ou en cas
       * d'affichage des housings liés à un domaine sur une page de type "liste de domaines" (page geo par exemple au clic sur "voir les hébergements").
       *
       * @type {{page}}
       */
      itemsParams.accommodation_params = {
        page: this.model.get('page')
      };
    }
    searchResultsEvent.ecommerce = {
      items: Tracking.generateAccommodationsDatas(itemsParams)
    };

    /**
     * Déclenchement de l'event
     */
    Tracking.dataLayerPush(searchResultsEvent);

    /**
     * Réinitialisation du tableau où sont stockés les résultats affichés dans la page.
     * En cas de soumission d'une nouvelle recherche en ajax, on évite ainsi de re-remonter des résultats déjà pushés.
     */
    trackResultItems = [];

    if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
      compareModule().then(({Compare}) => {
        window.Compare = Compare;
        new Compare().resetCompare();
      });
    }
  },

  /**
   * Get number of placeholder for lists with pagination
   * @param {ResultsListView|View} view
   */
  getNumberOfPlaceholder(view) {
    let searchParams = this.model.get('ajaxParametersCache');
    let total = parseInt(SEARCH_SCRIPTS.NB_PRODUCT);
    let page = parseInt(searchParams['page']);
    let nb = parseInt(searchParams['nb']);
    let news = total - (page * nb);
    view.setNumberOfPlaceholder(news > nb || news < 0 ? 10 : news);
  },

  getLocation: function () {
    $('.js-sortResult-item[data-sort=distance]').removeClass('u-disabled');
    $('.no-geoloc').addClass('u-Hidden');
  },

  getLocationError: function (error) {
    if (error.PERMISSION_DENIED) {
      $('.js-sortResult-item[data-sort=distance]').addClass('u-disabled');
      $('.no-geoloc').removeClass('u-Hidden');
      $('.js-mobileSortButton').addClass('toggle-active');
    }
  },

  displayResultList: function (isFilter, paginate = false) {
    const globalThis = this;

    if ($('.fixedFilters').length && !paginate && !DEVICE.isMobile) {
      genericScrollTo.go($('.searchbar'), 500, 0);
    }

    const datas = this.model.get('JSON_results');
    this.popinCottageCache = [];

    if (datas && datas.status === 'success') {
      // handling merchandising article
      let htmlMerchandising = '<div class="js-articleMessage"></div>';

      // init atricle messages
      this.articleMessage.getArticle();

      // if !paginate => reset pagination & reset the tracking arrays
      if (!paginate) {
        this.model.set('page', 1);
      }

      // remplacement des cartouches si le json est correctement chargé
      const resultList = datas.results.results,
        resultListSelected = datas.results.selected,
        nbParticipantsFirst = resultListSelected.multiparticipants.length ? parseInt(typeof datas.results.selected.multiparticipants[0].senior !== 'undefined' ? resultListSelected.multiparticipants[0].senior.code : 0) + parseInt(typeof datas.results.selected.multiparticipants[0].adult !== 'undefined' ? resultListSelected.multiparticipants[0].adult.code : 0) + parseInt(typeof datas.results.selected.multiparticipants[0].child !== 'undefined' ? resultListSelected.multiparticipants[0].child.code : 0) : 0,
        pageContainerClass = 'resultList-page_' + this.model.get('page'),
        totalResults = datas.results.totalDispo,
        sortBy = datas.results.parameters.sort,
        page = this.model.get('page'),
        hasMulticottage = datas.results.selected.multiparticipants.length > 1,
        hasBasket = sessionStorage.getItem('basketDatas') !== null;
      let cartouchesHtml = '';

      if (GLOBAL_SCRIPTS.CONTROLLER === 'product') {
        /* REGLE :
          on affiche d'abord les articles avec la value isBiased a true et dont le nb de personnes correspond exactement ==> resultPrio1
          ensuite on affiche les articles avec la value isBiased a true et donc le nb de personnes et a +2 ==> resultPrio2
           ensuite on affiche les articles avec la value isBiased a false et donc le nb de personnes est egal a la capacité ou a la capacité +2==>  resultSameCapacity
          ensuite on affiche les hebergement dispo dans l'ordre renvoyer (sans prendre en compte le isBiased)  ==> resultClassic
          enfin on affiche les hébergements non dispo en dernier ==> resultInsdispo
          comme chacun des cas correspond a un tableau different ,on utilise 2 index : unglobal (i), et l'autre propre au non prio (i2) pour pouvoir connaite le nb de cartouches affichés)
        */

        let resultPrio1 = Array(),
          resultPrio2 = Array(),
          resultSameCapacity = Array(),
          resultClassic = Array(),
          resultInsdispo = Array();

        const nbDiff = nbParticipantsFirst % 2 ? 4 : 3;
        const listNumber = JSON.parse(sessionStorage.getItem('basketDatas')) !== null && JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[0].isFilled ? 2 : 1;

        $.each(resultList, (key, item) => {
          const {bookingUpgrade, stock} = item.cache;
          const {isBiased, capacity} = item.housing;

          if (stock === 0 && typeof item.cache.bookingUpgrade.id === 'undefined') {
            resultInsdispo.push(item);
          } else {
            if (sortBy !== 'popularity_housing' && sortBy !== 'popularity' || (isBiased && capacity === nbParticipantsFirst) || (bookingUpgrade && Object.keys(bookingUpgrade).length)) {
              resultPrio1.push(item);
            } else if ((isBiased && (capacity - nbParticipantsFirst) < nbDiff) || (bookingUpgrade && Object.keys(bookingUpgrade).length)) {
              resultPrio2.push(item);
            } else if (((capacity - nbParticipantsFirst) < nbDiff) || (bookingUpgrade && Object.keys(bookingUpgrade).length)) {
              resultSameCapacity.push(item);
            } else if (stock > 0 || (bookingUpgrade && Object.keys(bookingUpgrade).length)) {
              resultClassic.push(item);
            }
          }
        });

        this.model.set('totalResults', totalResults);
        cartouchesHtml = '<div class="' + pageContainerClass + '"><div class="resultListPrio">';
        let i = 0;
        const WordingSearch = this.cacheWordings,
          wordings = this.wordingResults,
          nbPersons = this.mainEngineModel.get('totalParticipants'),
          wordingBtnSeeMore = SEARCH_SCRIPTS.WORDING_RESULT.see_more,
          wordingBtnSeeIndispo = SEARCH_SCRIPTS.WORDING_RESULT.see_indispo,
          nbFirstDisplay = resultPrio1.length + resultPrio2.length + resultSameCapacity.length;

        $.each([resultPrio1, resultPrio2, resultSameCapacity], function () {
          $.each(this, (key, item) => {
            const cartoucheDatas = {
              item: item,
              wordings: wordings,
              wordingsSearch: WordingSearch,
              wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
              wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
              controller: GLOBAL_SCRIPTS.CONTROLLER,
              hasMulticottage: hasMulticottage,
              listNumber: listNumber,
              nbPersons: nbPersons,
              resultListSelected: resultListSelected,
              position: (page - 1) * 10 + i,
              pageTemplate: PAGE_SCRIPTS.page_template
            };
            cartouchesHtml += globalThis.cartouche(cartoucheDatas, false, true);
            i++;

            //règle : on n'affiche l'article message qu'en deuxième position de toute la liste
            if (i === 1 && !paginate) {
              cartouchesHtml += htmlMerchandising;
            }
            if (!paginate) {
              if (SEARCH_SCRIPTS.GROUP === 'offer') {
                SEARCH_SCRIPTS['SEARCH_RESULT_' + i] = item.offer.code;
              }
              if (i < 2) {
                SEARCH_SCRIPTS.GEOLAT_FIRST_DOMAIN = item.geo.lat;
                SEARCH_SCRIPTS.GEOLON_FIRST_DOMAIN = item.geo.lon;
              }
            }
          });
        });
        cartouchesHtml += '</div>';
        if (sortBy === 'popularity_housing' || sortBy === 'popularity') {
          if (resultClassic.length !== 0 && nbFirstDisplay > 0) {
            cartouchesHtml += '<div class="seeMoreContainer"><a class="buttonContainer js-seeMoreCottage"><span class="button button--greenWhite">' + wordingBtnSeeMore + '</span></a></div>';
          }
          const additionalClass = resultClassic.length !== 0 && nbFirstDisplay > 0 ? ' u-Hidden' : '';
          cartouchesHtml += '<div class="resultListBy10' + additionalClass + '" >';
        }

        let i2 = 0;
        $.each([resultClassic], function () {
          $.each(this, (key, item) => {
            const cartoucheDatas = {
              item: item,
              wordings: wordings,
              wordingsSearch: WordingSearch,
              wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
              wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
              controller: GLOBAL_SCRIPTS.CONTROLLER,
              hasMulticottage: hasMulticottage,
              listNumber: listNumber,
              nbPersons: nbPersons,
              resultListSelected: resultListSelected,
              position: (page - 1) * 10 + i,
              pageTemplate: PAGE_SCRIPTS.page_template
            };
            cartouchesHtml += globalThis.cartouche(cartoucheDatas, false, true);
            i++;
            i2++;

            // Règle : on n'affiche l'article message qu'en deuxième position de toute la liste
            if (i === 1 && !paginate) {
              cartouchesHtml += htmlMerchandising;
            }
            if (i2 % 10 === 0 && i !== totalResults) {
              cartouchesHtml += '</div><div class="seeMoreContainer"><a class="buttonContainer js-seeMoreCottage"><span class="button button--greenWhite">' + wordingBtnSeeMore + '</span></a></div><div class="resultListBy10 u-Hidden">';
            }
            if (!paginate) {
              if (SEARCH_SCRIPTS.GROUP === 'offer') {
                SEARCH_SCRIPTS['SEARCH_RESULT_' + i] = item.offer.code;
              }
              if (i < 2) {
                SEARCH_SCRIPTS.GEOLAT_FIRST_DOMAIN = item.geo.lat;
                SEARCH_SCRIPTS.GEOLON_FIRST_DOMAIN = item.geo.lon;
              }
            }
          });
        });
        // affichage éventuel des housings non dispo
        if (resultInsdispo.length) {
          cartouchesHtml += '<div class="seeMoreContainer"><a class="buttonContainer js-seeMoreCottage"><span class="button button--transparentBlack">' + wordingBtnSeeIndispo + '</span></a></div><div class="resultListIndispo u-Hidden">';

          $.each(resultInsdispo, (key, item) => {
            i++;
            cartouchesHtml += globalThis.cartouche({
              item: item,
              wordings: this.wordingResults,
              wordingsSearch: this.cacheWordings,
              wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
              wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
              controller: GLOBAL_SCRIPTS.CONTROLLER,
              resultListSelected: resultListSelected,
              nbPersons: this.mainEngineModel.get('totalParticipants'),
              hasMulticottage: hasMulticottage,
              position: (page - 1) * 10 + i,
              pageTemplate: PAGE_SCRIPTS.page_template
            }, false, true);

            // règle : on n'affiche l'article message qu'en deuxième position de toute la liste
            if (i === 1 && !paginate) {
              cartouchesHtml += htmlMerchandising;
            }
          });
        }
        cartouchesHtml += '</div>';
      } else {
        // SCK Case
        cartouchesHtml = '<div class="' + pageContainerClass + '">';
        let arrNoDispoHousings = [];
        let i = 0;

        const hasDates = datas.results.selected.date[0] && datas.results.selected.date[0].key !== null;

        $.each(resultList, (key, item) => {
          if (SEARCH_SCRIPTS.GROUP === 'offer' || item.cache.stock > 0 || (item.cache.bookingUpgrade && Object.keys(item.cache.bookingUpgrade).length)) {
            i++;
            const cartoucheDatas = {
              item: item,
              wordings: this.wordingResults,
              wordingsSearch: this.cacheWordings,
              wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
              wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
              controller: GLOBAL_SCRIPTS.CONTROLLER,
              hasMulticottage: hasMulticottage,
              nbPersons: this.mainEngineModel.get('totalParticipants'),
              resultListSelected: resultListSelected,
              position: (page - 1) * 10 + i,
              pageTemplate: PAGE_SCRIPTS.page_template,
              hidePrice: hasMulticottage && !hasDates
            };

            cartouchesHtml += this.cartouche(cartoucheDatas, false, true);

            // Règle : on n'affiche l'article message qu'en deuxième position de toute la liste
            if (i === 1 && !paginate) {
              cartouchesHtml += htmlMerchandising;
            }

            if (!paginate) {
              if (SEARCH_SCRIPTS.GROUP === 'offer') {
                SEARCH_SCRIPTS['SEARCH_RESULT_' + i] = item.offer.code;
              }

              if (i < 2) {
                SEARCH_SCRIPTS.GEOLAT_FIRST_DOMAIN = item.geo.lat;
                SEARCH_SCRIPTS.GEOLON_FIRST_DOMAIN = item.geo.lon;
              }
            }
          } else {
            // Règle : pour les housings, on affiche les hébergements non dispo en dernier
            arrNoDispoHousings.push(item);
          }
        });

        // affichage éventuel des housings non dispo
        if (arrNoDispoHousings.length) {
          $.each(arrNoDispoHousings, (key, item) => {
            i++;
            cartouchesHtml += this.cartouche({
              item: item,
              wordings: this.wordingResults,
              wordingsSearch: this.cacheWordings,
              wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
              wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
              controller: GLOBAL_SCRIPTS.CONTROLLER,
              resultListSelected: resultListSelected,
              nbPersons: this.mainEngineModel.get('totalParticipants'),
              hasMulticottage: hasMulticottage,
              position: (page - 1) * 10 + i,
              pageTemplate: PAGE_SCRIPTS.page_template
            }, false, true);

            // règle : on n'affiche l'article message qu'en deuxième position de toute la liste
            if (i === 1 && !paginate) {
              cartouchesHtml += htmlMerchandising;
            }
          });
        }
        cartouchesHtml += '</div>';
      }

      // displaying cartouche in the cartouches container
      const $resultList = this.$el.find('#js-resultList');
      if (paginate) {
        $resultList.append(cartouchesHtml);
        loader.removeGhost('.resultList-paginationContainer');
      } else {
        $resultList.html(cartouchesHtml);
      }
      this.triggerSearchResultsEvent(1, false);

      // Initialisation of product photos slider
      dispatcher.trigger('sliderPhotos:init');

      // Init booking form
      bookingFormModule().then(({BookingForm}) => {
        this.bookingForm = new BookingForm();
      });

      // Mise à jour du nombre de résultats
      let startdate = '',
        enddate = '',
        capacity = this.mainEngineModel.get('totalParticipants');

      const strStartdate = this.mainEngineModel.get('arrivalDate'),
        strEnddate = this.mainEngineModel.get('departureDate');

      if (strStartdate !== '' && strEnddate !== '') {
        startdate = new Date(strStartdate);
        enddate = new Date(strEnddate);
      }

      if (!paginate) {
        // update result list header
        const headerResultParams = {
          nbResults: totalResults,
          capacity: capacity
        };

        this.updateResultListHeaderLabel(headerResultParams);
        SEARCH_SCRIPTS.NB_PRODUCT = totalResults;

        // handling no results
        if (totalResults === 0) {
          $('#domainAccommodations-noResults').closest('.CommonContentBlock').removeClass('u-Hidden');
        } else {
          $('#domainAccommodations-noResults').closest('.CommonContentBlock').addClass('u-Hidden');
        }
      }

      if ((10 * page) >= totalResults) {
        $('.resultList-paginationContainer').addClass('u-Hidden');
      } else {
        $('.resultList-paginationContainer').removeClass('u-Hidden');
      }

      if (totalResults > 1) {
        $('.js-mobileSortButton').removeClass('u-disabled');
        $('.resultList-HeaderSort').removeClass('u-Hidden');
      } else {
        $('.js-mobileSortButton').addClass('u-disabled');
        $('.resultList-HeaderSort').addClass('u-Hidden');
      }

      if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
        $('.switch-comparerContainer').toggleClass('u-Hidden--forced', totalResults <= 1);
      }

      loader.remove('#js-resultList');
      if (!$('.searchForm-block.opened').length) {
        // SPECIAL CONDITION RESET SEARCH MC
        if ($('.pika-single.arrival').hasClass('is-hidden') && $('.pika-single.departure').hasClass('is-hidden') && !$('.searchForm-capacityContainer:visible').length) {
          $('body').removeClass('searchFocused');
        }
      }

      // handling cartouche type specificity
      if (SEARCH_SCRIPTS.GROUP !== 'offer') {
        dispatcher.trigger('search:resultList:showLightDetails', '.' + pageContainerClass);
        dispatcher.trigger('popinParticipants:init');
      }

      // reset model temporary variables ( submitForm, eventType );
      this.model.set({'eventType': false}, {'silent': true});
      this.mainEngineModel.set({'submitForm': false}, {'silent': true});

      if (typeof cartoucheMSG_article !== 'undefined' && cartoucheMSG_article.date) {
        this.initCartoucheMsgPopin();
      }

      // DISPLAY CARTOUCHE PRODUCT WHEN NO BASKET
      if (hasMulticottage && !hasBasket && !$('.cartoucheDomain-container').length && !$('.ctDom').length) {
        const participantsFirstCottage = this.model.get('mainSearch').getResume().multiparticipants[0];

        let htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
          title: this.wordingsMultiCottage.addCottageTitle + ' 1',
          number: '1',
          participants: {
            senior: participantsFirstCottage.seniors,
            adult: participantsFirstCottage.adults,
            child: participantsFirstCottage.ages.length,
            pet: participantsFirstCottage.pets
          }
        });

        $('.cartMultiProductBlock').remove();
        this.$resultListHeader.prepend(htmlCartoucheMultiCottage);
      }

      // handling counterproposal
      if (!hasMulticottage) {
        this.displayCounterProposal(false);
      }

      $('.js-goToFilters').toggleClass('isMulticottage', hasMulticottage);
    } else {
      // reset eventType
      this.model.set({'eventType': false}, {'silent': true});
    }

    if (!isFilter && (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' || GLOBAL_SCRIPTS.CONTROLLER === 'product')) {
      basketMulticottageViewModule().then(({BasketMulticottageView}) => {
        this.basketMulticottageView = new BasketMulticottageView(this.mainEngineModel);
      });

      $('.basket-container').removeClass('disabled');
    }

    if (isFilter) {
      $('.js-basketMulticottage').off().on('click', (e) => {
        e.preventDefault();
        dispatcher.trigger('basket:addBasket', e);
      });
    }

    // remove button loaders
    setTimeout(function () {
      button.clearButtonLoader();
    }, 200);

    $('.js-openDateCartouche').on('click', e => {
      e.preventDefault();
      if (DEVICE.isMobile) {
        $('body').addClass('body-searchMobileEngineOpen');
        $('#mainContainer').addClass('searchEngineOpened');
      }
      dispatcher.trigger('facette:dates:display', 'show', '.js-search-date_begin');

      // TRACKING
      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Choose your date',
        gaLabel: 'Multi Cottage / Park block ' + PAGE_SCRIPTS.page_template + ' / Item_Choose your date',
        event: 'clickEvent'
      });
    });

    dispatcher.trigger('searchView:initStickySearch');

    // init guirlande de noel
    if (!DEVICE.isDesktop) {
      $('.ctDom').each((i, target) => {
        this.eventUspJingleBells(target);
      });
    }

    if ($('.basket-container').length === 0) {
      $('body').removeClass('basketOpened');
    }
  },

  // rendu de la liste de cartouches
  render: function (paginate = false) {
    if (!paginate) {
      this.getNumberOfPlaceholder(this);
      dispatcher.trigger('search:displayLoader', this.numberOfPlaceholder);
    }

    if (this.mainEngineModel.get('submitForm')) {
      // récupération de l'article message puis affichage de la liste de résultat en callback
      new ArticleMessageView({
        model: this.mainEngineModel,
        tpl: this.banner,
        callback: ['search:resultList:displayResultList', 'slider:init', 'search:resultList:initFancyMerchOffer', 'heightEqualizer:reset'],
        callbackParam: ['', '.js-merchOffer-slider', '', '']
      });
    } else {
      // affichage de la liste de résultat
      this.displayResultList(true, paginate);
    }
  },

  paginate: function () {
    const currentPage = this.model.get('page') + 1;
    this.model.set('page', currentPage);
    this.getNumberOfPlaceholder(this);
    loader.displayGhost('.resultList-paginationContainer', 'sck', this.numberOfPlaceholder, true);
  },

  updateResultListHeaderLabel: function (params) {
    const nbResults = params.nbResults;

    if (!nbResults) {
      this.$resultListHeaderText.addClass('u-Hidden');
      this.$resultListHeaderNoHousingAlert.removeClass('u-Hidden');
      this.$resultListHeaderText.html(SEARCH_SCRIPTS.WORDING_RESULT.sort_main_label_zero_results);
    } else {
      this.$resultListHeaderNoHousingAlert.addClass('u-Hidden');
      this.$resultListHeaderText.removeClass('u-Hidden');

      let resultListHeaderText = '',
        mainLabelSingular = '',
        mainLabelPlural = '';

      if (SEARCH_SCRIPTS.GROUP === 'offer') {
        mainLabelSingular = this.cacheWordings.result_list_offer_header_singular;
        mainLabelPlural = this.cacheWordings.result_list_offer_header_plural;
      } else {
        mainLabelSingular = this.cacheWordings.result_list_housing_header_singular;
        mainLabelPlural = this.cacheWordings.result_list_housing_header_plural;
      }

      const mainLabel = nbResults > 1 ? mainLabelPlural : mainLabelSingular;
      const totalCottage = this.model.get('temporarySearch').getResume().accommodationNb;
      resultListHeaderText = `
        <strong>
          <span id="totalresults">${nbResults}</span> ${mainLabel}
        </strong>`;

      if (nbResults < 2) {
        // on cache le selecteur de tri
        this.$sortDropdown.hide(0);
        resultListHeaderText = nbResults === 0 ? SEARCH_SCRIPTS.WORDING_RESULT.sort_main_label_zero_results : resultListHeaderText;
      } else {
        this.$sortDropdown.show(0);
      }

      this.$resultListHeaderText.html(resultListHeaderText);
      dispatcher.trigger('search:filters:updateCounter', nbResults);

      $('#js-flexDates').toggleClass('u-Hidden--forced', totalCottage > 1);
      let scrollTarget = '.resultList-Header',
        offset = DEVICE.isMobile ? $('.js-searchForm-toggler').outerHeight() + 30 : 80;

      if (GLOBAL_SCRIPTS.CONTROLLER === 'country' || GLOBAL_SCRIPTS.CONTROLLER === 'product' || (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' && $('#js-resultList').find('.accCart').length > 0)) {
        $('.cartMultiProductBlock').remove();

        if (totalCottage > 1) {
          if ($('.leadGen').length) {
            $('.leadGen').hide();
          }
        } else {
          scrollTarget = '.js-resultList-headerText';
          offset = !DEVICE.isMobile ? 130 : offset;
          if ($('.leadGen').length) {
            $('.leadGen').show();
          } else {
            dispatcher.trigger('leadGenView:init');
          }
        }

        if (sessionStorage.getItem('basketDatas') !== null) {
          $('body').removeClass('basketOpened');
        }
      } else {
        $('.cartMultiBlock, .cartMulti').remove();
        if (GLOBAL_SCRIPTS.CONTROLLER === 'search' || (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' && this.$resultListHeader.find('.accCart').length > 0)) {
          if (totalCottage > 1) {
            let htmlCartoucheMultiCottage = cartoucheMultiCottage({
              title: this.wordingsMultiCottage.titleCartouche,
              text1: this.wordingsMultiCottage.text1Cartouche,
              text2: this.wordingsMultiCottage.text2Cartouche,
              pushNumber: 1
            });
            $(htmlCartoucheMultiCottage).insertBefore(this.$resultListHeader);
          } else {
            dispatcher.trigger('leadGenView:init');
          }
        }
      }

      if (!DEVICE.isMobile) {
        genericScrollTo.go(scrollTarget, 500, offset);
      }

      this.displayPushBottomMultiCottage();
      if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
        $('.switch-comparerContainer').toggleClass('u-Hidden--forced', nbResults === 1);
      }
    }
  },

  // cartouche bottom FP/search
  displayPushBottomMultiCottage: function () {
    $('.cartMultiBlock.fullWidth').remove();
    const totalCottage = this.model.get('mainSearch').getResume().accommodationNb;
    const participtantFirst = typeof this.model.get('mainSearch').getResume().multiparticipants[0] !== 'undefined' ? this.model.get('mainSearch').getResume().multiparticipants[0] : {};
    const totalParticipantsFirst = participtantFirst.adults + participtantFirst.seniors + participtantFirst.ages.length;
    const participtantSecond = typeof this.model.get('mainSearch').getResume().multiparticipants[1] !== 'undefined' ? this.model.get('mainSearch').getResume().multiparticipants[1] : {};
    const totalParticipantsSecond = participtantSecond.adults + participtantSecond.seniors + participtantSecond.ages.length;
    const totalParticipants = totalParticipantsFirst + totalParticipantsSecond;
    const hasToDisplayPushSingleCottage = totalCottage > 1 && totalParticipants > 7 && totalParticipants < 13 ? true : false;
    const hasToDisplayPushMultiCottage = totalCottage < 2 && totalParticipantsFirst > 5 ? true : false;

    if (hasToDisplayPushMultiCottage) {
      $('.cartMultiBlock.fullWidth').remove();

      let htmlPushMultiCottage = '<div class="cartMultiBlock fullWidth">' + cartoucheMultiCottage({
        hasToDisplayPushMultiCottage: true,
        title: this.wordingsMultiCottage.pushMultiTitle,
        smallTitle: true,
        text1: this.wordingsMultiCottage.pushMultiText,
        buttonLabel: this.wordingsMultiCottage.pushMultiButtonLabel,
        pushNumber: 2
      }) + '</div>';

      this.$resultListIdContainer.append(htmlPushMultiCottage);
    }

    if (hasToDisplayPushSingleCottage) {
      $('.cartMultiBlock.fullWidth').remove();
      let htmlPushSingleCottage = '<div class="cartMultiBlock fullWidth">' + cartoucheMultiCottage({
        hasToDisplayPushSingleCottage: true,
        title: this.wordingsMultiCottage.pushSingleTitle,
        text1: this.wordingsMultiCottage.pushSingleText,
        buttonLabel: this.wordingsMultiCottage.pushSingleButtonLabel,
        pushNumber: 1
      }) + '</div>';

      this.$resultListIdContainer.append(htmlPushSingleCottage);
    }

    if (hasToDisplayPushSingleCottage || hasToDisplayPushMultiCottage) {
      $('.js-action').on('click', ({currentTarget}) => {
        setTimeout(function () {
          if (DEVICE.isMobile) {
            $('.searchToggler-dateParticipants').click();
          } else {
            $('.searchForm-capacity .js-displaySearchFormList.js-searchForm-dataOpener').click();
          }
        }, 10);

        // TRACKING
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Bouton interested',
          gaLabel: 'Banner push ' + $({currentTarget}).data().pushnumbercottage + 'x_interested',
          event: 'popindisplay'
        });
      });
    }
  },

  sortResult: function (datas) {
    const sort = datas.sort;

    if (sort === 'distance') {
      this.validSortDatas = datas;
      // on teste la présence du cookie de geolocation
      if (cookieManagement.getCookie('userLocation') === null) {
        geoloc.init('search:resultList:handleSortByDistance', 'search:resultList:denySortByDistance');
      } else {
        this.handleSortByDistance();
        // on mémorise le fait qu'il faut lancer le render après la validation de la geoloc
        if (typeof GMAP_SCRIPTS !== 'undefined') {
          GMAP_SCRIPTS.CALLBACK = this.validSort;
        }
      }
    } else {

      // cancel the callback on gmap localisation
      if (typeof GMAP_SCRIPTS !== 'undefined') {
        GMAP_SCRIPTS.CALLBACK = '';
      }

      // mise à jour du modèle
      const oUpdate = {'order': datas.order, 'sort': sort};
      this.model.set(oUpdate);

      // on met à jour le wording pour la version mobile du tri
      $('.js-mobileSortButton').removeClass('toggle-active');
    }

    if (DEVICE.isMobile) {
      setTimeout(() => {
        $('#mainContainer').removeClass('searchSortOpened');
        genericScrollTo.canIScroll(DEVICE.isMobile);
      }, 300);
    }
    // TRACKING
    const filterData = sort+'_'+datas.order;
    const gaLabel = {
      popularity_asc: 'Popularity',
      price_asc: 'Ascending price',
      price_desc: 'Descending price',
      capacity_asc: 'Number of rooms',
      distance_desc: 'Distance'
    } ;

    Tracking.dataLayerPush({
      event: 'clickEvent',
      gaCategory: 'park comparator',
      gaAction: 'Drop down list filter',
      gaLabel: gaLabel[filterData]
    });
  },

  handleSortByDistance: function () {
    this.validSort(geoloc.getUserLocation());
  },

  denySortByDistance: function () {
    $('.js-sortResult-item[data-sort=popularity]').first().click();
    $('.js-sortResult-item[data-sort=distance]').addClass('u-disabled');
    $('.no-geoloc').removeClass('u-Hidden');
    $('.js-mobileSortButton').addClass('toggle-active');
  },

  validSort: function (point) {
    // mise à jour du modèle
    this.model.set({
      order: 'asc',
      sort: 'distance',
      lat: point.lat,
      long: point.long
    });

    // on met à jour le wording pour la version mobile du tri
    $('.js-mobileSortButton').removeClass('toggle-active');
  },

  tabChangedCallback: function () {
    // Initialisation of product photos slider after tab change
    setTimeout(() => {
      dispatcher.trigger('sliderPhotos:init');
    }, 200);
  },

  buildBedroomNumberList: function (arrOffers, productCode) {
    let htmlListDesktop = '<ul class="accCart-tabInner--searchDomain">',
      htmlListMobile = `
    <div class="form-Select domainAccommodations-roomSelect u-Visible-mobile">
      <select name="domainAccommodations-selector" id="domainAccommodations-selector_${productCode}" class="form-selectItem js-displayRoomTab">`;

    let firstLoop = true;
    let hasHousing = false;
    let indexLoop = 0;

    $.each(arrOffers, (index, item) => {
      const tabLabel = index > 1 ? this.wordingResults.label_room_tab_plural : this.wordingResults.label_room_tab_singular;
      let strHousingList = '';

      // reset housing list for tracking
      if (firstLoop) {
        this.arrTrackingHousingId = [];
      }

      let isStock = false;
      $.each(item, (i, product) => {
        strHousingList += (i > 0 ? ',' : '') + product.housing.code;
        // update housing list for tracking
        if (firstLoop) {
          this.arrTrackingHousingId.push(product.housing.code);
        }

        if (product.cache.stock > 0) {
          isStock = true;
        }
      });

      if (isStock === true && hasHousing === false) {
        this.indexhasHousing = indexLoop;
        hasHousing = true;
      }

      htmlListDesktop += `
        <li class="accCart-tabInner--item js-tabsAccoCart${firstLoop ? ' selected' : ''}" data-tabcode="${productCode}_roomTab_${index}">
          <span class="domainAccommodations-roomLabel js-Tracking--link" data-tracking='{"clickCode":"clickHousingsTab","gaCategory":"${PAGE_SCRIPTS.page_template}","gaAction":"Click on housing tab","gaLabel":"${index} ${tabLabel}","gaValue":1,"housingList":"${strHousingList}"}'>${index} ${tabLabel}</span>
        </li>`;

      htmlListMobile += `
        <option value="#${productCode}_roomTab_${index}" class="js-Tracking--link" data-tracking='{"clickCode":"selectHousingsTab","gaCategory":"${PAGE_SCRIPTS.page_template}","gaAction":"mobile select housing tab","gaLabel":"${index} ${tabLabel}","gaValue":1,"housingList":"${strHousingList}"}'>
          ${index} ${index > 1 ? this.wordingResults.label_room_tab_plural : this.wordingResults.label_room_tab_singular}
        </option>`;

      firstLoop = false;
      indexLoop++;
    });

    htmlListDesktop += '</ul>';
    htmlListMobile += `
      </select>
    </div>`;

    return htmlListDesktop + htmlListMobile;
  },

  displayHousings: function (event) {
    event.preventDefault();
    const $link = $(event.currentTarget),
      $targetDiv = $($link.data('target')),
      dateStart = $link.data('startdate'),
      dateEnd = $link.data('enddate'),
      productCode = $link.data('code'),
      cartoucheType = $link.data('cartouchetype'),
      hasBasket = sessionStorage.getItem('basketDatas') !== null,
      basketDatas = hasBasket ? JSON.parse(sessionStorage.getItem('basketDatas')) : null,
      hasFullBasket = hasBasket && basketDatas.cottagesSelected[0].isFilled && JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[1].isFilled;

    if ($link.hasClass('js-close')) {// js-close = classe marqueur d'action "close" sur les boutons de display
      const $button = $link.hasClass('closeAccommodationsButton') ? $($link.data('button')) : $link,
        $buttonText = $button.find('span.button');
      $buttonText.html($link.data('labelopen'));
      $button.removeClass('js-close');
      $targetDiv.hide(0);
      $('.cartMultiProductBlock').hide(0);
    } else {// click sur le bouton d'ouverture
      const $buttonText = $($link.find('span.button')),
        $housingContainer = $('#js-smallCartoucheContainer_' + productCode),
        labelClose = $link.data('labelclose');
      let domainPosition = 0;

      if ($housingContainer.length) {
        const $resultList = $housingContainer.closest('#js-resultList');
        const $domainContainer = $housingContainer.closest('.cartoucheDomain-container');

        if ($resultList.length && $domainContainer.length) {
          const $domainContainers = $resultList.find('.cartoucheDomain-container');

          if ($domainContainers.length > 1) {
            domainPosition = $domainContainers.index($domainContainer) + 1;
          } else {
            domainPosition = 1;
          }
        }
      }

      $targetDiv.show(0);
      $('.cartMultiProductBlock').show(0);
      $link.addClass('js-close');
      $buttonText.html(labelClose);

      // Updating biasing
      if (SEARCH_SCRIPTS.COLLECTION !== GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_GEO') {
        dispatcher.trigger('cookie:updateBiasingSearch', productCode, 2);
      }

      if (!$.trim($housingContainer.html())) {// si le container est vide
        loader.displayGhost('#js-accommodation_' + $link.data('code'), 'park', 1, true);

        const successCallback = datas => {
          if (datas.status === 'success') {

            const resultList = datas.results.results;
            const resultListSelected = datas.results.selected;
            const hasMulticottage = resultListSelected.multiparticipants.length > 1;
            const hasBasket = sessionStorage.getItem('basketDatas') !== null;
            const basketDatas = hasBasket && JSON.parse(sessionStorage.getItem('basketDatas'));
            // tri des cartouches par nombre de chambre
            let arrOffers = {},
              arrOffer = [];

            $.each(resultList, (index, offer) => {
              arrOffer = typeof arrOffers[offer.housing.nbBedroom] !== 'undefined' ? arrOffers[offer.housing.nbBedroom] : [];
              arrOffer.push(offer);
              arrOffers[offer.housing.nbBedroom] = arrOffer;
            });
            // construction de la liste de housings
            let cartouchesHtml = '';

            this.indexhasHousing = 0;
            // ajout de la liste des liens des tabs
            let housingHtml = this.buildBedroomNumberList(arrOffers, productCode);

            // Active right tab bedroom when back from resa
            const resaNbRoom = getUrlParameter('selected[nb_bedroom]');
            if (typeof resaNbRoom !== 'undefined') {
              this.indexhasHousing = Object.keys(arrOffers).indexOf(resaNbRoom);
            }

            // ajout de la div container pour les tabs
            cartouchesHtml += `
              <div class="u-Visible-mobile h4-like domainAccommodations-housingListTitle">${this.wordingResults.housing_list_title}</div>
              <div class="accCart-tabs">`;

            // ajout de la liste des liens des tabs
            cartouchesHtml += housingHtml;
            cartouchesHtml += `</div>
                               <div class="td-elems gb-list">`;
            // ajout des blocks de cartouches rangés par nombre de chambre
            let count = 0;

            $.each(arrOffers, (nbRoom, offerList) => {
              let hasNoDispoHousing = false;
              cartouchesHtml += `<div id="${productCode}_roomTab_${nbRoom}" class="domainAccommodations-roomTabContent${count === 0 ? ' visible' : ''}" data-tabcode="${productCode}_roomTab_${nbRoom}" data-index="${count}">`;

              $.each(offerList, (index, offer) => {
                if (offer.cache.stock > 0) {
                  cartouchesHtml += this.cartouche({
                    item: offer,
                    index: index,
                    wordings: this.wordingResults,
                    wordingsSearch: this.cacheWordings,
                    wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
                    wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
                    resultListSelected: resultListSelected,
                    nbPersons: this.mainEngineModel.get('totalParticipants'),
                    modifier: count === 0 ? ' accCart--first' : '',
                    hasMulticottage: hasMulticottage,
                    position: (count + 1),
                    domainPosition: domainPosition,
                    pageTemplate: PAGE_SCRIPTS.page_template,
                    controller: GLOBAL_SCRIPTS.CONTROLLER,
                    cartoucheType: cartoucheType
                  }, true, true);
                  count++;
                } else {
                  hasNoDispoHousing = true;
                }
              });

              if (hasNoDispoHousing) {// si on gère l'affichage des housings non dispo
                cartouchesHtml += `<p class="h4-like domainAccommodations-housingFullTitle">${this.wordingResults.housing_full_title}</p>`;
                count = 0;
                $.each(offerList, (index, offer) => {
                  if (offer.cache.stock === 0) {
                    cartouchesHtml += this.cartouche({
                      item: offer,
                      index: index,
                      wordings: this.wordingResults,
                      wordingsSearch: this.cacheWordings,
                      wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
                      wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
                      nbPersons: this.mainEngineModel.get('totalParticipants'),
                      resultListSelected: resultListSelected,
                      modifier: count === 0 ? ' accCart--first' : '',
                      position: (count + 1),
                      domainPosition: domainPosition,
                      pageTemplate: PAGE_SCRIPTS.page_template,
                      controller: GLOBAL_SCRIPTS.CONTROLLER
                    }, true, true);
                    count++;
                  }
                });
              }
              count++;
              cartouchesHtml += '</div>';
            });
            cartouchesHtml += '</div>';
            loader.removeGhost('#js-accommodation_' + $link.data('code'));

            $housingContainer.html(cartouchesHtml);
            this.triggerSearchResultsEvent(1, false);

            // Initialisation of product photos slider
            dispatcher.trigger('sliderPhotos:init');

            // on instancie les actions sur pour ouvrir la popin cartouche MSG
            if (typeof cartoucheMSG_article !== 'undefined' && cartoucheMSG_article.date) {
              this.initCartoucheMsgPopin();
            }

            if (DEVICE.isMobile) {
              this.initCustomSelect();
            }
            dispatcher.trigger('search:resultList:showLightDetails', '#js-smallCartoucheContainer_' + productCode);
            dispatcher.trigger('popinParticipants:init');

            basketMulticottageViewModule().then(({BasketMulticottageView}) => {
              // initialise basket
              this.basketMulticottageView = new BasketMulticottageView(this.model.get('mainSearch'));

              // DISPLAY CARTOUCHE FOR SCK DOMAIN PAGE
              if (hasMulticottage && ($('.cartoucheDomain-container').length || $('.ctDom').length)) {
                const participants = this.model.get('mainSearch').getResume().multiparticipants;
                const numberCottage = !hasBasket ? 1 : basketDatas.cottagesSelected[1].isFilled ? 1 : 2;
                const i = numberCottage - 1;
                let htmlCartoucheMultiCottage = '';

                if (!hasFullBasket) {
                  htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
                    title: this.wordingsMultiCottage.addCottageTitle + ' ' + numberCottage,
                    number: numberCottage,
                    participants: {
                      senior: participants[i].seniors,
                      adult: participants[i].adults,
                      child: participants[i].ages.length,
                      pet: participants[i].pets
                    }
                  });
                } else {
                  $('.accCart-bookingButton .button').addClass('disabled');
                  htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
                    title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitleFilled
                  });
                }

                $('.cartMultiProductBlock').remove();
                $('.accCartList').prepend(htmlCartoucheMultiCottage);
              }
            });

            bookingFormModule().then(({BookingForm}) => {
              // Init booking form
              this.bookingForm = new BookingForm();
            });
          }

          genericScrollTo.go($('#js-accommodation_' + productCode), 500, 66);
        };

        // récupération des paramètres de recherche
        dispatcher.trigger('searchModel:updateSearchParams');
        let ajaxParams = this.model.get('ajaxParametersCache');
        // ajout des paramètres spécifiques
        ajaxParams.group = 'housing';
        ajaxParams['facet[COUNTRYSITE][]'] = 'l2_' + productCode;
        ajaxParams['facet[DATE]'] = dateStart;
        ajaxParams['facet[DATEEND]'] = dateEnd;
        ajaxParams['facet[DISPO]'] = -1;
        ajaxParams['dateuser'] = 1;
        ajaxParams['accreditation'] = GLOBAL_SCRIPTS.ACCREDITATION;
        ajaxParams['accreditationGroup'] = GLOBAL_SCRIPTS.ACCREDITATION_GROUP;
        ajaxParams['cacheuser'] = GLOBAL_SCRIPTS.CACHE_USER;

        if (SEARCH_SCRIPTS.DISPLAY_PRICE !== '') {
          ajaxParams['displayPrice'] = SEARCH_SCRIPTS.DISPLAY_PRICE;
        }

        let referer = window.location.protocol + '//' + window.location.host + window.location.pathname;
        ajaxParams['referer'] = encodeURIComponent(referer);

        // on va chercher le json contenant les 3 housings
        const ajaxData = {
          ajaxUrl: SEARCH_SCRIPTS.URL_API_SEARCH,
          ajaxParams: ajaxParams,
          successCallback: successCallback,
          dataType: 'json',
          type: 'GET'
        };

        genericAjaxCall(ajaxData);
      } else {
        genericScrollTo.go($('#js-accommodation_' + productCode), 500, 66);
      }
    }

    $(document).on('click', '.js-tabsAccoCart', e => {
      const $currentTarget = $(e.currentTarget);
      $currentTarget.parent('.accCart-tabInner--searchDomain').find('.accCart-tabInner--item').removeClass('selected');
      $currentTarget.addClass('selected');
      $currentTarget.parents('.accCart-container').find('.domainAccommodations-roomTabContent').removeClass('visible');
      $('#' + $currentTarget.data('tabcode')).addClass('visible');
    });

    // remove button loaders
    setTimeout(function () {
      button.clearButtonLoader();
    }, 200);
  },

  eventUspJingleBells: function (target) {
    const $target = $(target);
    const $items = $target.find('.ctDom-uspBlockItem p');
    let height = 0;

    $items.each((i, item) => {
      height = item.offsetHeight > height ? item.offsetHeight : height;
      if (height > 15) $('.ctDom-uspBlockList').height(45 + height);
    });

    function switchClass(target) {
      const $target = $(target);
      let $itemActive = $target.find('.ctDom-uspBlockItem.active');
      $itemActive = $itemActive.removeClass('active').next('.ctDom-uspBlockItem');
      if ($itemActive.length === 0) $itemActive = $target.find('.ctDom-uspBlockItem').first();
      $itemActive.addClass('active');
    }

    const timer = setInterval(function () {
      switchClass(target);
    }, 1800);

    $target.find('.ctDom-uspBlockItem').on('click', e => {
      clearInterval(timer);
      const $currentTarget = $(e.currentTarget);
      $currentTarget.parent('.ctDom-uspBlockList').find('.ctDom-uspBlockItem').removeClass('active');
      $currentTarget.addClass('active');

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'USP Bloc parcs',
        gaLabel: $currentTarget.find('img').attr('alt'),
        event: 'clickEvent'
      });
    });
  },

  initSeeMoreBtn: function () {
    $(document).on('click', '.js-seeMoreCottage', function () {
      const Target = $(this).closest('.seeMoreContainer');

      Target.next('.u-Hidden').removeClass('u-Hidden');
      Target.remove();

      Tracking.dataLayerPush({
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: $('.resultList-HeaderText').text(),
        gaLabel: $(this).hasClass('showIndispo') ? 'Voir les hébergements épuisés' : 'Voir plus d’hebergements',
        event: 'clickEvent'
      });

      // Trigger slider when a new element enters the viewport upon clicking the "See More" button.
      dispatcher.trigger('sliderPhotos:init');
    });
  },

  initArticleMessages: function () {
    this.articleMessage = new ArticleMessageView({
      model: this.mainEngineModel,
      tpl: this.banner,
      appendDatas: true,
      eltSelector: '.js-articleMessage',
      callback: ['slider:init', 'search:resultList:initFancyMerchOffer', 'heightEqualizer:reset'],
      callbackParam: ['.js-merchOffer-slider', '', '']
    });
  },

  initCartoucheMsgPopin: function () {
    if (typeof initCartoucheMsg !== 'undefined' && initCartoucheMsg) {
      new FancyboxView({
        selector: '.js-fancybox-cartoucheMsg',
        fancyType: 'custom',
        options: {
          infobar: false,
          toolbar: true,
          buttons: ['close', 'fullScreen']
        }
      });
    }
  },
  callLightDetails: function (url) {
    const popinIdContainer = '#js-popinCottageDetails';
    const $body = $('body');
    const $popinContainer = $(popinIdContainer);
    if (typeof this.popinCottageCache[url] === 'undefined') {
      const successCallback = datas => {
        this.popinCottageCache[url] = datas;
        $popinContainer.append(datas);
        // while new css file appending
        setTimeout(function () {
          loader.removeGhost(popinIdContainer);
          dispatcher.trigger('sliderPhotos:render', $('.popinCottageDetails .js-sliderPhotos'));
        }, 400);

        button.clearButtonLoader();
        dispatcher.trigger('tooltip:close');
      };
      const ajaxData = {
        ajaxUrl: url,
        successCallback: successCallback,
        dataType: 'html',
        type: 'GET'
      };
      genericScrollTo.storeOffsetTop();
      $popinContainer.empty().scrollTop(0);
      $body.removeClass('basketOpened').addClass('popinCottage');
      loader.displayGhost(popinIdContainer, 'cottageDetail', 1, true);
      genericScrollTo.canIScroll(DEVICE.isMobile);
      genericAjaxCall(ajaxData);
    } else {
      $popinContainer.empty().append(this.popinCottageCache[url]).scrollTop(0);
      $body.removeClass('basketOpened').addClass('popinCottage');

      setTimeout(function () {
        button.clearButtonLoader();
        genericScrollTo.canIScroll(DEVICE.isMobile);
      }, 600);
      dispatcher.trigger('tooltip:close');
    }
  },

  showLightDetails: function (selector = false) {
    const usedSelector = selector ? selector + ' .js-lightCottageDetails' : '.js-lightCottageDetails';

    $(usedSelector).on('click', (event) => {
      const $currentTarget = $(event.currentTarget);
      const urlPopin = $currentTarget.data('src');
      this.callLightDetails(urlPopin);
    });
  },

  initAfterLightDetails: function () {
    const scrollAfterIframe = $(document).scrollTop() + 1;
    genericScrollTo.go(scrollAfterIframe, 1000, 0);
  },

  housingMoreInfo: function (event) {
    if (SEARCH_SCRIPTS.COLLECTION !== GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_GEO') {
      const $currentTarget = $(event.currentTarget),
        productCode = $currentTarget.data('productcode');

      dispatcher.trigger('cookie:updateBiasingSearch', productCode, 2);
    }
  },

  initCustomSelect() {
    new Form.CustomSelect('.js-displayRoomTab', {}, e => {
      $('.domainAccommodations-roomTabContent').hide(0);
      $(e.currentTarget.getAttribute('value')).show(0, () => {
        this.tabChangedCallback();
      });
    });
  },

  displayCounterProposal(is_page_load) {
    /*** REGLES : on n'affiche les contrepropositions que si la recherche est de type offre, s'il y a moins de 4 résultats, et si les dates sont remplies ***/
    if (SEARCH_SCRIPTS.GROUP === 'offer' && SEARCH_SCRIPTS.NB_PRODUCT < 4 && this.mainEngineModel.get('arrivalDate')) {
      const successCallback = datas => {
        if (datas.status === 'success' && datas.results.total > 0) {
          const resultList = datas.results.results,
            resultListSelected = datas.results.selected,
            title = this.wordingResults.counterproposal_title,
            hasMulticottage = typeof datas.results.selected !== 'undefined' && datas.results.selected.multiparticipants.length > 0;
          let cartouchesHtml = '<div id="js-resultList-counterproposal" class="resultList-counterproposal">',
            memoSubtitle = '',
            i = 0,
            displayCounterProposal = false;
          $.each(resultList, (key, item) => {
            if (item.cache.dispo > 0) {
              i++;

              let arrivalDate = new Date(item.cache.date);
              let departureDate = new Date(item.cache.dateEnd);
              let duration = item.cache.duration;
              // build dynamic subtitle by use datesFromTo utility
              const labelCounterProposal = new Date(this.mainEngineModel.get('arrivalDate')).getTime() === arrivalDate.getTime() ? this.wordingResults.counterproposal_subtitle : this.wordingResults.counterproposal_other_date;
              const dateLabel = datesFromTo(arrivalDate, departureDate, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_counter_proposal, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);
              const wordingNight = duration === 1 ? this.wordingsCommon.night : this.wordingsCommon.nights;
              const durationLabel = ` (${(duration + 1)} ${this.wordingsCommon.days} / ${duration} ${wordingNight})`;
              const subtitleDate = dateLabel + durationLabel;

              if (!displayCounterProposal) {
                cartouchesHtml += `<div class="resultList-title"><h2 class="resultList-title--main">${title}</h2><h3 class="resultList-title--txt"><span class="resultList-title--bold">${labelCounterProposal}</span> ${subtitleDate}</h3></div>`;
              } else if (memoSubtitle !== subtitleDate) {
                cartouchesHtml += `<div class="resultList-title"><h3 class="resultList-title--txt"><span class="resultList-title--bold">${labelCounterProposal}</span> ${subtitleDate}</h3></div>`;
              }

              if (memoSubtitle !== subtitleDate) {
                memoSubtitle = subtitleDate;
              }

              cartouchesHtml += this.cartouche({
                item: item,
                wordings: this.wordingResults,
                wordingsSearch: this.cacheWordings,
                wordingIcones: SEARCH_SCRIPTS.WORDING_ICONES,
                wordingsCommon: GLOBAL_SCRIPTS.WORDINGS_COMMON,
                controller: GLOBAL_SCRIPTS.CONTROLLER,
                resultListSelected: resultListSelected,
                nbPersons: this.mainEngineModel.get('totalParticipants'),
                hasMulticottage: hasMulticottage,
                position: i,
                pageTemplate: PAGE_SCRIPTS.page_template,
                cartoucheType: 'counterproposal'
              }, false, false);
              displayCounterProposal = true;
            }
          });

          if (displayCounterProposal) {
            cartouchesHtml += '</div>';
            this.$el.find('#js-resultList').append(cartouchesHtml);

            //Initialisation of product photos slider
            dispatcher.trigger('sliderPhotos:init');
          }
        }
      };

      //setting ajax parameters
      dispatcher.trigger('searchModel:updateSearchParams');
      let ajaxParams = this.model.get('ajaxParametersCache');
      //ajout des paramètres spécifiques
      ajaxParams.group = 'offer';
      ajaxParams.dateuser = 1;
      ajaxParams.accreditation = GLOBAL_SCRIPTS.ACCREDITATION;
      ajaxParams.accreditationGroup = GLOBAL_SCRIPTS.ACCREDITATION_GROUP;
      ajaxParams.cacheuser = GLOBAL_SCRIPTS.CACHE_USER;

      if(!!ajaxParams['exclude[]']){
        ajaxParams['exclude[]'] = [];
        for (const country of SEARCH_SCRIPTS.DEFAULT_MAIN_SEARCH.countrysite) {
          ajaxParams['exclude[]'].push(country.code);
        }
      }

      ajaxParams['geo[lat]'] = SEARCH_SCRIPTS.GEOLAT_FIRST_DOMAIN;
      ajaxParams['geo[lon]'] = SEARCH_SCRIPTS.GEOLON_FIRST_DOMAIN;

      delete ajaxParams['asc'];
      delete ajaxParams.sort;

      const ajaxData = {
        ajaxUrl: SEARCH_SCRIPTS.URL_API_COUNTERPROPOSAL,
        ajaxParams: ajaxParams,
        successCallback: successCallback,
        dataType: 'json',
        type: 'GET'
      };
      genericAjaxCall(ajaxData);
    }
  },

  setNumberOfPlaceholder: function (number) {
    this.numberOfPlaceholder = number;
  },

  initFancyMerchOffer: function () {
    const fancyClass = '.js-merchOffer-fancybox';
    if ($(fancyClass).length) {
      new FancyboxView({
        selector: fancyClass,
        fancyType: 'custom',
        options: {
          infobar: false,
          toolbar: true,
          preventMobileScroll: true,
          buttons: ['close', 'fullScreen']
        }
      });
    }

    if ($('.js-merchOffer-slider').length) {
      resize.addToFunctionList(this.resetMerchOfferSlider);
    }
  },

  resetMerchOfferSlider: function () {
    dispatcher.trigger('slider:init', '.js-merchOffer-slider');
    heightEqualizer.reset(500);
  },

  merchFancyOpen: function () {
    const scrollClass = '.js-merchOffer-customScroll';
    if ($(scrollClass).length) {
      setTimeout(function () {
        //-- custom scrollbar in fancybox on open
        customScrollbar.init(scrollClass, true);
      }, 400);
    }
  }

});